import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=3be0fcc8&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=3be0fcc8&prod&lang=scss&scoped=true&"
import style1 from "./HeroSection.vue?vue&type=style&index=1&id=3be0fcc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0fcc8",
  null
  
)

export default component.exports